import ButtonWithLoader from "@/common/components/ui/loading/ButtonLoading";
import { useDeleteFileOrder } from "@/common/hooks";
import { Modal } from "flowbite-react";
import { useFormik } from "formik";
import { useParams } from "react-router-dom";

type Props = {
  file: string
  onClose: () => void
  onDeleteSuccess: (deletedFile: string) => void
}

function ModalDeleteFile(props: Props) {
  const { purchaseOrderId } = useParams();
  const { mutateAsync: deleteFile } = useDeleteFileOrder()

  const handleDeleteFile = async (data) => {
    await deleteFile(data);
    props.onDeleteSuccess(props.file);
    props.onClose();
  }

  const formik = useFormik({
    initialValues: { file: props.file, purchaseOrderId: purchaseOrderId as string },
    onSubmit: async (data) => handleDeleteFile(data)
  })

  return (
    <Modal show={true} onClose={props.onClose}>
      <Modal.Header className="text-black dark:text-black">
        <h2 className="text-black dark:text-black">{`Tem certeza que deseja deletar este arquivo: ${props.file} ?`}</h2>
      </Modal.Header>
      <Modal.Body>
        <ButtonWithLoader onClick={formik.handleSubmit}>Deletar</ButtonWithLoader>
      </Modal.Body>
    </Modal>
  )
}

export default ModalDeleteFile;
